import { render, staticRenderFns } from "./ListSessions.vue?vue&type=template&id=dd07a818&scoped=true"
import script from "./ListSessions.vue?vue&type=script&lang=js"
export * from "./ListSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd07a818",
  null
  
)

export default component.exports